import {Component, OnInit} from '@angular/core';
import {Locale} from '../../model/locale';
import {Program} from '../../model/program';
import {OperatorProgramsService} from '../../services/operator-programs.service';
import {LocalesService} from '../../services/locales.service';
import {factory} from '../../shared/app-logging';
import {Product} from '../../model/product';
import {ProgramProductsService} from '../../services/program-products.service';
import {OperatorsService} from '../../services/operators.service';
import {Operator} from '../../model/operator';

const logger = factory.getLogger('TemplateBulkEditComponent');

@Component({
  selector: 'app-template-bulk-edit',
  templateUrl: './template-bulk-edit.component.html',
  styleUrls: ['./template-bulk-edit.component.scss']
})
export class TemplateBulkEditComponent implements OnInit {
  locales: Locale[];
  localeSel: Locale;
  products: Product[];
  productSel: Product;

  constructor(private operatorsService: OperatorsService,
              private operatorProgramsService: OperatorProgramsService,
              private localesService: LocalesService,
              private programProductsService: ProgramProductsService) {
  }


  ngOnInit() {
    // Load Locales
    this.localesService.findLocales().subscribe(locales => {
      this.locales = locales;
      // Select default Locale
      if (this.locales) {
        this.localeSel = this.locales.find(l => l.localeName === 'en_US');
      }
    });

    // Load Operators
    this.operatorsService.findOperators().subscribe(operators => {
      logger.debug(`${operators.length} operators loaded`);

      if (operators) {
        // Load Programs
        this.operatorProgramsService.findProgramsWithOperator(operators).subscribe(programs => {
          logger.debug(`${programs.length} programs loaded`);

          // Select default Program
          if (programs) {
            // Load Products
            this.programProductsService.findProductsWithProgram(programs).subscribe(products => {
              logger.debug(`${products.length} products loaded`);

              const defaultOperator = new Operator(null, 'DEFAULT');
              const defaultProgram = new Program(null, defaultOperator, 'DEFAULT', 'DEFAULT', 'DEFAULT');
              const defaultProduct = new Product(null, defaultProgram, 'DEFAULT');

              // Insert default Operator-Program-Product at the beginning
              this.products = [defaultProduct].concat(this.programProductsService.sortProducts(products));

              // Select default Product
              if (this.products) {
                this.productSel = this.products[0];
              }
            });
          }
        });
      }
    });
  }

}
